import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { QuizProgressPopUpContentType } from '@edtech-ui/constants/quiz-progress-pop-up.enum';

@Component({
	selector: 'app-progress-quiz-dialog-box',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './progress-quiz-dialog-box.component.html',
	styleUrl: './progress-quiz-dialog-box.component.scss'
})
export class ProgressQuizDialogBoxComponent {
	@Input() progress: number = 0;
	quizProgressPopUpContentType = QuizProgressPopUpContentType;

	constructor(
		public dialogRef: MatDialogRef<ProgressQuizDialogBoxComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { progress: number; type: QuizProgressPopUpContentType }

	) { }

	get isTopic(): boolean {
		return this.data.type === QuizProgressPopUpContentType.TOPIC;
	}

	get isQuestion(): boolean {
		return this.data.type === QuizProgressPopUpContentType.QUESTION;
	}
}